import {InjectionKey, Ref, ShallowRef} from "vue";
import {FormConfig} from "/@src/components/custom/form/BaseForm.vue";
import {EditorConfig} from "/@src/components/custom/editor/RichEditor.vue";
import {Editor} from "@tiptap/core";
import {FormFieldLayout} from "/@src/components/custom/form/BaseFormField.vue";


export const injectKeyFormData:InjectionKey<Ref<Object>> = Symbol('formData');
export const injectKeyFormConfig:InjectionKey<Ref<FormConfig>> = Symbol('formConfig');
export const injectKeyFormFieldLayout:InjectionKey<FormFieldLayout> = Symbol('formFieldLayout');
export const injectKeyUpdateFormData:InjectionKey<(field:string|null, value:any, index?:number)=>void> = Symbol('updateFormData');
export const injectKeyFormArrayContainer:InjectionKey<Ref<HTMLElement>|null> = Symbol('formArrayContainer');


export const injectRegisterFormPreExcuteHooks:InjectionKey<(hook:() => Promise<any>)=>void> = Symbol('register form Pre-Excute Hooks')

export const injectRegisterFormResetHooks:InjectionKey<(hook:() => Promise<any>|void)=>void> = Symbol('register form reset Hooks')
export const injectUnRegisterFormPreExcuteHooks = Symbol('unregister form Pre-Excute Hooks')

export const injectRegisterFormValidateHooks:InjectionKey<(hook:() => Promise<boolean>)=>void> = Symbol('register form rule')

export const injectUnRegisterFormValidateHooks = Symbol('unregister form rule Hooks')

export const injectEditor:InjectionKey<ShallowRef<Editor|undefined>> = Symbol('text-editor')
export const injectEditorConfig:InjectionKey<EditorConfig> = Symbol('text-editor-config')

export const injectEditorSelectionUpdateHooks:InjectionKey<Array<(editor:Editor)=>void>> = Symbol('register editor selection update Hooks')
